export default __webpack_public_path__ + "static/cyber-background-15b43e8f6fa47f073175181e691b994c.jpg";